"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.H2 = void 0;
const Box_1 = require("./Box");
exports.H2 = Box_1.Box.withComponent('h2');

//# sourceMappingURL=H2.js.map
